import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {MatDialog} from '@angular/material/dialog';

@Injectable({providedIn: 'root'})
export class DialogService {

    constructor(
        private dialog: MatDialog
    ) {
    }

    openModal(component: any, disableClose = false): Observable<any> {
        const dialogRef = this.dialog.open(component,
            {
                backdropClass: 'dark-backdrop',
                panelClass: 'tm-file-preview-dialog-panel',
                // tslint:disable-next-line:object-literal-shorthand
                disableClose: disableClose
            });
        return dialogRef.afterClosed();
    }

    openModalWithDisabledClose(component: any): Observable<any> {
        const dialogRef = this.dialog.open(component,
            {
                backdropClass: 'dark-backdrop',
                panelClass: 'tm-file-preview-dialog-panel',
                disableClose: true,

            });
        return dialogRef.afterClosed();
    }

    openModalWithParams(component: any, params: any, disableClose = false): Observable<any> {
        const dialogRef = this.dialog.open(component,
            {
                backdropClass: 'dark-backdrop',
                panelClass: 'dialog-panel',
                // tslint:disable-next-line:object-literal-shorthand
                disableClose: disableClose,
                data: params,
            });
        return dialogRef.afterClosed();
    }
}
